import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useState } from "react";
const RechargeHistory = () => {
  const [startdate, setstartdate] = useState(
    new Date().toLocaleDateString("en-CA")
  );

  return (
    <>
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <div className="row">
            <div className="col-sm-4">
              <h4>
                <b>Recharge Report</b>
              </h4>
            </div>
            <div className="col-sm-2">
              <DatePicker
                className="form-control datepick"
                selected={startdate}
                onChange={(date) => setstartdate(date)}
                dateFormat="yyyy-MM-dd"
                placeholderText={startdate}
              />
            </div>

            <div className="col-sm-2">
              <input
                type="text"
                className="form-control"
                placeholder="Keyword"
                name="keyword"
                id="keyword"
              />
            </div>

            <div className="col-sm-4">
              <button
                type="button"
                className="btn btn-success"
                id="rechargeSearchBtn"
              >
                Search
              </button>
              {/* <a className="btn btn-secondary">View All</a> */}
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table table-bordered table-striped"
              id="rechargeDataTable"
              width="100%"
              cellspacing="0"
            >
              <thead>
                <tr>
                  <th>#</th>
                  <th>RechargeID</th>
                  <th>MemberID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Operator</th>
                  <th>Amount</th>
                  <th>OB</th>
                  <th>CB</th>
                  <th>Date Time</th>
                  <th>Status</th>
                  <th>Complain</th>
                </tr>
              </thead>
              <tr>
                <th colspan="11" style={{ textAlign: "center" }}>
                  There is no data in table
                </th>
              </tr>
              <tfoot>
                <tr>
                  <th>#</th>
                  <th>RechargeID</th>
                  <th>MemberID</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Operator</th>
                  <th>Amount</th>
                  <th>OB</th>
                  <th>CB</th>
                  <th>Date Time</th>
                  <th>Status</th>
                  <th>Complain</th>
                </tr>
              </tfoot>
              <tbody></tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default RechargeHistory;
